import React, { Component } from 'react';

import { scaleLinear } from 'd3-scale';

import './Scale.css';

class Scale extends Component {

  render() {
    let sizing = {
      height: 600,
      width: 50,
      fontSize: '14',
      fontFamily: 'Helvetica',
      keyLeft: '46'
    };
    if (this.props.small) {
      sizing.height = 350;
      sizing.width = 40;
      sizing.fontSize = '11';
      sizing.fontFamily = 'Helvetica';
      sizing.keyLeft = '36';
    }
    let style = {
      fill: "url('#gradient')"
    };
    let scale = scaleLinear().domain([this.props.max, this.props.min]).range([14, (sizing.height - 4)]);
    let ticks = scale.ticks().map((d) => {
      let translate = 'translate('+ String(sizing.keyLeft) +', '+ String(scale(d)) +')';
      let style = {
        textAnchor: 'end',
        fill: 'black',
        fontWeight: '800'
      };
      style.fontSize = sizing.fontSize + 'px';
      style.fontFamily = sizing.fontFamily;
      return (
        <g key={d} transform={translate}>
          <text style={style}>{d}</text>
        </g>
      )
    });
    let valueKey = (
      <g>
        {ticks}
      </g>
    );
    let labelStyle = {
      fill: 'black',
      fontFamily: sizing.fontFamily,
      fontSize: (Number(sizing.fontSize) + 3) + 'px',
      fontWeight: '800'
    };

    let keyLabel = (
      <text transform="rotate(90) translate(4, 0)" y="0" dy="-4" style={labelStyle}>6 hours of recent rainfall in inches</text>
    )
    return (
      <svg width={sizing.width} height={sizing.height} id="colorkey">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%" spreadMethod="pad">
            <stop offset="0%" stopColor={this.props.endcolor} stopOpacity="1"></stop>
            <stop offset="100%" stopColor={this.props.startcolor} stopOpacity="1"></stop>
          </linearGradient>
        </defs>
        <rect width={sizing.width} height={sizing.height} style={style}></rect>
        {valueKey}
        {keyLabel}
      </svg>
    )
  }
}

export default Scale;



// WEBPACK FOOTER //
// ./src/components/Scale.js